import React from 'react';
import { Invoice, PaymentGateway, UpcomingInvoice } from '~/types/models';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';
import { InvoiceListRow } from './InvoiceListRow';
import { Title } from '../../Common/Title';
import cx from 'classnames';
import useCurrentTeam from '~/react-hooks/use-current-team';

export interface InvoiceListPanelProps {
  upcomingInvoice?: UpcomingInvoice | null;
  invoices?: Invoice[];
}

export function InvoiceListPanel({
  upcomingInvoice,
  invoices,
}: InvoiceListPanelProps) {
  const { payment_gateway, payment_gateway_id } = useCurrentTeam();
  const isShopify = payment_gateway == PaymentGateway.Shopify;
  const shop = payment_gateway_id.replace('.myshopify.com', '');

  return (
    <div className='flex flex-col gap-y-4 w-full max-w-[800px]'>
      <Title label='Invoice' />
      {isShopify ? (
        <div className='text-base'>
          Your invoices are generated and emailed automatically by Shopify. If
          you want to see your Billing information and invoices,&nbsp;
          <a
            href={`https://admin.shopify.com/store/${shop}/settings/billing`}
            rel='noopener noreferer noreferrer'
            target='_blank'
            className='underline v2-text-neutral-500 active:v2-text-neutral-500 hover:v2-text-neutral-900 text-base font-thin'
          >
            visit your Shopify dashboard.
          </a>
        </div>
      ) : (
        <div className='flex flex-col border-y border-x-0 v2-border-neutral-300 border-solid'>
          {upcomingInvoice && (
            <InvoiceListRow
              icon={
                <i className='icon icon-calendar-plain !v2-bg-neutral-500' />
              }
              titleLabel='Upcoming charge'
              dateLabel={upcomingInvoice?.date}
              totalLabel={upcomingInvoice?.total}
            />
          )}
          {invoices?.map((invoice) => {
            return (
              <InvoiceListRow
                key={invoice.id}
                className={cx({
                  'border-t border-b-0 border-x-0': upcomingInvoice,
                  'border-solid v2-border-neutral-300': upcomingInvoice,
                })}
                icon={
                  <FontAwesomeIcon
                    icon={faCheck}
                    className='w-3 h-3 rounded-full v2-text-white v2-bg-blue-500 p-1'
                  />
                }
                titleLabel={invoice?.status}
                dateLabel={invoice?.date}
                totalLabel={
                  <div className='flex flex-row gap-x-4'>
                    <span>{invoice?.total}</span>
                    {invoice.discount && (
                      <span className='rounded-full py-1 px-2 v2-bg-yellow-500 text-black text-xs'>
                        {invoice.discount} off
                      </span>
                    )}
                  </div>
                }
                downloadId={invoice?.id}
              />
            );
          })}
        </div>
      )}
    </div>
  );
}
